module.exports = __webpack_public_path__ + "img/beerhelps.af8bd261.svg";